import React from "react";

/**
 * Generated cover used wherever a project or article has no photography.
 * Deterministic: the same title always produces the same composition.
 */
const accents = {
  azure: {
    bg: "bg-gradient-brand",
    text: "text-paper",
    mark: "text-electric/30",
    rule: "bg-electric/50",
  },
  onyx: {
    bg: "bg-[linear-gradient(140deg,#1A1953_0%,#11103a_65%,#080616_100%)]",
    text: "text-paper",
    mark: "text-electric/25",
    rule: "bg-electric/45",
  },
  electric: {
    bg: "bg-[linear-gradient(140deg,#2F2FE4_0%,#2424b8_60%,#162E93_100%)]",
    text: "text-paper",
    mark: "text-paper/[0.08]",
    rule: "bg-paper/50",
  },
  paper: {
    bg: "bg-paper-warm dark:bg-night-raised",
    text: "text-ink dark:text-slightwhite",
    mark: "text-azure/10 dark:text-electric/15",
    rule: "bg-azure/30 dark:bg-electric/30",
  },
};

const initialsOf = (title = "") =>
  title
    .replace(/[^a-zA-Z\s]/g, " ")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

const EditorialCover = ({
  title = "",
  kicker,
  accent = "azure",
  className = "",
}) => {
  const tone = accents[accent] || accents.azure;

  return (
    <div
      className={`relative flex h-full w-full flex-col justify-between overflow-hidden ${tone.bg} ${tone.text} ${className}`}
      aria-hidden="true"
    >
      <div className="noise-panel pointer-events-none absolute inset-0 opacity-[0.18] mix-blend-overlay" />

      {/* Scrim so the title reads at the same weight on every gradient. */}
      {accent !== "paper" && (
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-white/[0.06]" />
      )}

      {/* concentric arcs */}
      <svg
        className="pointer-events-none absolute -right-[22%] -top-[28%] h-[150%] w-[110%] opacity-25"
        viewBox="0 0 400 400"
        fill="none"
      >
        {[70, 120, 170, 220].map((r) => (
          <circle
            key={r}
            cx="260"
            cy="150"
            r={r}
            stroke="currentColor"
            strokeWidth="0.75"
          />
        ))}
      </svg>

      <div className="relative z-10 flex items-center justify-between p-6">
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] opacity-70">
          {kicker || "Selected Work"}
        </span>
        <span className={`h-px w-10 ${tone.rule}`} />
      </div>

      <span
        className={`pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-display text-[9rem] font-semibold leading-none ${tone.mark}`}
      >
        {initialsOf(title)}
      </span>

      <div className="relative z-10 p-6">
        <p className="font-display text-2xl leading-tight drop-shadow-sm md:text-3xl">
          {title}
        </p>
      </div>
    </div>
  );
};

export default EditorialCover;
